import React from 'react';
import { Checkbox } from '../../../components/ui/Checkbox';
import Icon from '../../../components/AppIcon';

const VisibilitySettings = ({ settings, onSettingsChange }) => {
  const handleChange = (field, value) => {
    onSettingsChange({
      ...settings,
      [field]: value,
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
          증명 공개 설정
        </h3>
        <p className="text-sm text-muted-foreground caption">
          증명 제출 시 기본 공개 범위를 설정하세요
        </p>
      </div>
      <div className="space-y-3">
        <div className="p-4 bg-card rounded-lg border border-border">
          <Checkbox
            label="증명을 기본적으로 공개"
            description="체크하면 제출한 증명이 다른 사용자에게 공개됩니다"
            checked={settings?.defaultPublic || false}
            onChange={(e) => handleChange('defaultPublic', e?.target?.checked)}
          />
        </div>

        <div className="p-4 bg-card rounded-lg border border-border">
          <Checkbox
            label="순차적 잠금 해제 활성화"
            description="이전 증명을 완료해야 다음 타일이 잠금 해제됩니다"
            checked={settings?.sequentialUnlock !== false}
            onChange={(e) => handleChange('sequentialUnlock', e?.target?.checked)}
          />
        </div>

        <div className="p-4 bg-card rounded-lg border border-border">
          <Checkbox
            label="완료 시 축하 애니메이션 표시"
            description="챌린지 완료 시 게이밍 스타일 축하 효과를 보여줍니다"
            checked={settings?.celebrationAnimation !== false}
            onChange={(e) => handleChange('celebrationAnimation', e?.target?.checked)}
          />
        </div>
      </div>
      <div className="flex items-start space-x-3 p-4 bg-muted/50 rounded-md">
        <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
        <div className="flex-1">
          <p className="text-sm text-foreground mb-1 font-medium">
            설정 안내
          </p>
          <p className="text-xs text-muted-foreground caption">
            이 설정은 챌린지 생성 후에도 언제든지 변경할 수 있습니다. 각 증명 제출 시 개별적으로 공개 범위를 조정할 수도 있습니다.
          </p>
        </div>
      </div>
    </div>
  );
};

export default VisibilitySettings;